import { render, staticRenderFns } from "./ResetUserPasswordSidebar.vue?vue&type=template&id=fa51b1c6&scoped=true&"
import script from "./ResetUserPasswordSidebar.vue?vue&type=script&lang=js&"
export * from "./ResetUserPasswordSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ResetUserPasswordSidebar.vue?vue&type=style&index=0&id=fa51b1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa51b1c6",
  null
  
)

export default component.exports